/**
 * See "POS Client Integration Guide v2.1 - 15th April 2015.pdf" page 64.
 *
 * @type {{string: {id: number, message: string, parameters?:string[]}}}
 */
const Actions = {
    BYPASS_PIN: {
        id: 1,
        message: 'Bypass PIN',
    },
    CONTINUE_TRANSACTION: {
        id: 2,
        message: 'Continue Transaction',
    },
    CONFIRM_SIGNATURE: {
        id: 3,
        message: 'Confirm Signature',
    },
    REJECT_SIGNATURE: {
        id: 4,
        message: 'Reject Signature',
    },
    REPRINT_RECEIPT: {
        id: 5,
        message: 'Reprint Receipt',
        parameters: ['REPRINTOPT'],
    },
    VOICE_REFERRAL_AUTHORISED: {
        id: 7,
        message: 'Voice Referral Authorised',
        parameters: ['AUTHCODE'],
    },
    VOICE_REFERRAL_REJECTED: {
        id: 8,
        message: 'Voice Referral Rejected',
    },
    CANCEL_TRANSACTION: {
        id: 12,
        message: 'Cancel Transaction',
    },
    ALTERNATE_PAYMENT: {
        id: 13,
        message: 'Alternate Payment',
    },
    CONFIRM_AUTH_CODE: {
        id: 20,
        message: 'Confirm Auth Code',
    },
    REJECT_AUTH_CODE: {
        id: 21,
        message: 'Reject Auth Code',
    },
    CHARGE_AUTH_CODE: {
        id: 22,
        message: 'Charge Auth Code',
        parameters: ['AUTHCODE'],
    },
    REVERSE_UAT_ICC_TXN: {
        id: 23,
        message: 'Reverse UAT ICC Txn',
    },
    RETRY_DEVICE: {
        id: 24,
        message: 'Retry Device',
    },
    CONTINUE_WITHOUT_DEVICE: {
        id: 25,
        message: 'Continue Without Device',
    },
    ABORT_DEVICE_CONNECTIVITY: {
        id: 26,
        message: 'Abort Device Connectivity',
    },
    RETRY_DOWNLOAD: {
        id: 27,
        message: 'Retry Download',
    },
    CANCEL_DOWNLOAD: {
        id: 28,
        message: 'Cancel Download',
    },
    CASHBACK_REQUIRED: {
        id: 29,
        message: 'Cashback Required',
        parameters: ['CASHBACK'],
    },
    CASHBACK_NOT_REQUIRED: {
        id: 30,
        message: 'Cashback Not Required',
    },
    RESTART: {
        id: 31,
        message: 'Restart',
    },
    ACCEPT_UNSAFE_DOWNLOAD: {
        id: 32,
        message: 'Accept Unsafe Download',
    },
    REJECT_UNSAFE_DOWNLOAD: {
        id: 33,
        message: 'Reject Unsafe Download',
    },
    REPLACE_ACCOUNT: {
        id: 34,
        message: 'Replace Account',
        parameters: ['MGRPIN'],
    },
    CANCEL_REPLACE_ACCOUNT: {
        id: 35,
        message: 'Cancel Replace Account',
    },
    ACCOUNT_ON_FILE_REGISTRATION_REQUIRED: {
        id: 38,
        message: 'Account On File Registration Required',
    },
    ACCOUNT_ON_FILE_REGISTRATION_NOT_REQUIRED: {
        id: 39,
        message: 'Account On File Registration Not Required',
    },
    ATTEMPT_TO_RECONNECT: {
        id: 40,
        message: 'Attempt To Reconnect',
    },
    GO_OFFLINE: {
        id: 41,
        message: 'Go Offline',
    },
    SELECT_PAYPOINT_ACCOUNT: {
        id: 42,
        message: 'Select PayPoint Account',
        parameters: ['PAYPOINTACCID'],
    },
    SELECT_PAYPOINT_OPTION: {
        id: 43,
        message: 'Select PayPoint Option',
        parameters: ['PAYPOINTOPTIONID'],
    },
    RETRY_PAYPOINT_CONFIRMATION: {
        id: 44,
        message: 'Retry PayPoint Confirmation',
    },
    CANCEL_PAYPOINT_CONFIRMATION: {
        id: 45,
        message: 'Cancel PayPoint Confirmation',
    },
    ACCEPT_LICENCE_KEY: {
        id: 46,
        message: 'Accept Licence Key',
    },
    REJECT_LICENCE_KEY: {
        id: 47,
        message: 'Reject Licence Key',
    },
    CANCEL_LICENCE_KEY_VERIFICATION: {
        id: 48,
        message: 'Cancel Licence Key Verification',
    },
    CONTINUE_LICENCE_KEY_VERIFICATION: {
        id: 49,
        message: 'Continue Licence Key Verification',
    },
    CONFIRM_PARK_RETAIL_GIFT_TRANSACTION: {
        id: 52,
        message: 'Confirm Park Retail Gift Transaction',
    },
    REVERSE_PARK_RETAIL_GIFT_TRANSACTION: {
        id: 53,
        message: 'Reverse Park Retail Gift Transaction',
    },
    CANCEL_GET_CARD_DETAILS: {
        id: 54,
        message: 'Cancel Get Card Details (GDET)',
    },
    NO_TRANSACTION_VALUE_UPDATE_REQUIRED: {
        id: 55,
        message: 'No Transaction Value Update Required',
    },
    TRANSACTION_VALUE_UPDATE_REQUIRED: {
        id: 56,
        message: 'Transaction Value Update Required',
        parameters: ['TXNVALUE'],
    },
    MERCHANT_CURRENCY_REQUIRED: {
        id: 57,
        message: 'Merchant Currency Required',
    },
    CARDHOLDER_CURRENCY_REQUIRED: {
        id: 58,
        message: 'Cardholder Currency Required',
    },
    MERCHANT_REFERENCE_ENTERED: {
        id: 59,
        message: 'Merchant Reference Entered',
        parameters: ['REF'],
    },
    SUPPLY_IVR_DETAILS: {
        id: 60,
        message: 'Supply IVR Details',
    },
    REJECT_IVR: {
        id: 61,
        message: 'Reject IVR',
    },
    PRINT_SHOP_COPY_RECEIPT: {
        id: 62,
        message: 'Print Shop Copy Receipt',
    },
    CANCEL_SHOP_COPY_RECEIPT: {
        id: 63,
        message: 'Cancel Shop Copy Receipt',
    },
    SUPPLY_STAN: {
        id: 64,
        message: 'Supply STAN',
    },
    ACCEPT_PART_PAYMENT: {
        id: 65,
        message: 'Accept Part Payment',
    },
    REJECT_PART_PAYMENT: {
        id: 66,
        message: 'Reject Part Payment',
    },
    FURTHER_PAYMENT_REQUIRED: {
        id: 67,
        message: 'Further Payment Required',
    },
    NO_FURTHER_PAYMENT_REQUIRED: {
        id: 68,
        message: 'No Further Payment Required',
    },
};

module.exports = Actions;
